import { Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import Class from "./Class";
import IEntity from "./IEntity";
import Logger from "./Logger";

/**
 * temporary helper to copy mutation entity prototypes
 */

const QUERY = "__query__";

enum ActionOperation {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
	DELETE = "DELETE"
}

class ActionResult {

	@Field()
	public entityId: ID;

	@Field()
	public operationPerformed: ActionOperation;

}

const actionResult = new ActionResult();

export function actionResultFrom(Clazz: Class<IEntity>): Class<IEntity> {
	const instance = new Clazz();

	console.log(instance);

	if (typeof instance === 'object' && typeof instance[QUERY] === 'object') {
		const args = instance[QUERY];

		// tslint:disable-next-line
		return class {
			constructor() {
				this[QUERY] = {
					...actionResult[QUERY],
					create: args.create,
					delete: args.delete,
					update: args.update
				};
			}

			public id: ID;
		};
	}

	Logger.throw("invalid action result class!");
}

/**
 * for param functions, since typegraph doesn't automatically wrap the params in object
 */
export const toParams = (obj: any) => ({params: obj});



// WEBPACK FOOTER //
// ./src/core/util/MutationUtil.ts